<template>
  <div class="wrapper">
    <swiper :options="swiperOption">
      <swiper-slide v-for='(item, index) of swiperList' :key="index" :style="{backgroundImage:'url('+item.img+')'}">
        <div class="swiper-content">
            <div class="swiper-item-title t1">{{item.title1}}</div>
            <div class="swiper-item-title t2">{{item.title2}}</div>
            <div class="swiper-item-title t3">{{item.title3}}</div>
            <div class="swiper-item-title t4">{{item.title4}}</div>
            <div class="swiper-goto-button" @click='goto(item)'>
                <p>了解更多</p>
                <img :src="RightTriangle" alt="">
            </div>
        </div>
      </swiper-slide>
      <div
        class="swiper-pagination swiper-pagination-white"
        slot="pagination"
      ></div>
      <div
        class="swiper-button-prev animated"
        :class="{bounceInLeft:swiperButton}"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next animated"
        :class="{bounceInRight:swiperButton}"
        slot="button-next"
      ></div>
    </swiper>
  </div>
</template>

<script>
import Bg1 from '@/assets/img/bg1.png'
import RightTriangle from '@/assets/img/right-triangle.png'
import {bannerlist} from '@/api/header.js'
export default {
  name: 'Banner',
  data () {
    return {
      RightTriangle,
      // 显示左右切换
      swiperButton: false,
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // spaceBetween: 30,
        speed: 500,
        autoplay: 3000,
        autoplayDisableOnInteraction: false,
        effect: 'fade',
        loop: true
      },
      swiperList: [
        {
          img: Bg1
        }]
    }
  },
  created () {
    this.getbanner()
  },
  methods: {
    getbanner () {
      bannerlist().then(res => {
        this.swiperList = res.data.data.items
      })
    },
    goto (item) {
      if (item.url.includes('https://') || item.url.includes('http://')) {
        window.open(item.url)
        return
      }
      this.$router.push({
        path: item.url,
        query: {
          img: item.img
        }
      })
    }
  }
}
</script>

<style scoped lang="scss" >
.wrapper {
  width: 100%;
  height: 960px;
  overflow: hidden;
  position: relative;
  .swiper-container {
    height: 100%;
    .swiper-container:hover .swiper-button-prev{
      background: rgba($color: #000000, $alpha: 0.3)
    }
    .swiper-container:hover .swiper-button-next{
      background: rgba($color: #000000, $alpha: 0.1)
    }
    .swiper-slide{
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .swiper-pagination {
        bottom: 70px;
        .swiper-pagination-bullet {
            width: 110px;
            height: 4px;
            background: #fff;
            border-radius: 0;
        }
    }
    .swiper-slide {
      background-position: center center;
      background-repeat: no-repeat;
    }
    .swiper-button-prev,
    .swiper-button-next {
      width: 44px;
      height: 138px;
      top: 45%;
      background: rgba($color: #000000, $alpha: 0.1)
    }
    .swiper-button-prev {
      left: 0;
      background: rgba($color: #000000, $alpha: 0.3)  url('../../assets/img/control-nav.png') no-repeat 0 0;
    }
    .swiper-button-next {
      right: 0;
      background: rgba($color: #000000, $alpha: 0.3) url('../../assets/img/control-nav.png') no-repeat -46px 0;
    }
  }
}

.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 1px;
}

.swiper-content {
    width: 100%;
    height: 100%;
    position: relative;
    padding:0 130px;
    box-sizing: border-box;
}
.swiper-item-title{
  text-align: center;
}
.t1{
  margin-top:262px;
  margin-bottom:27px;
  font-size:90px;
font-family:SourceHanSansCN;
font-weight:500;
color:rgba(255,255,255,1);
line-height:126px;
text-shadow:0px 0px 35px rgba(0, 0, 0, 0.2);
}
.t2{
   margin-bottom:17px;
  font-size:54px;
font-family:SourceHanSansCN;
font-weight:500;
color:rgba(255,255,255,1);
// line-height:122px;
text-shadow:0px 0px 35px rgba(0, 0, 0, 0.2);
}
.t3{
   margin-bottom:27px;
  font-size:28px;
font-family:Arial;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
text-shadow:0px 0px 13px rgba(0, 0, 0, 0.2);
}
.t4{
  font-size:28px;
font-family:Arial;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
text-shadow:0px 0px 13px rgba(0, 0, 0, 0.2);
}
.swiper-goto-button {
    width: 220px;
    height: 46px;
    border-radius: 10px;
    background: rgba($color: #ffffff, $alpha: 0.1);
    position: absolute;
    // bottom: 253px;
    top:450px;
    left: 50%;
    z-index: 1000;
    transform: translateX(-50%);
    border: 2px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: rgba($color: #0a06f5, $alpha: 0.1)
    }
    p {
        font-weight: bold;
        font-size: 16px;
        color: #fff;
    }
    img {
        width: 17px;
        height: 7px;
        position: absolute;
        right: 9px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/banner.vue